import React from "react"
import CompanyPillarsComponent from "./CompanyPillars"
import companyPillarsFactory from "./companyPillars.factory"

export { default as CompanyPillarsQuery } from "./companyPillars.query"

export const CompanyPillars = props => {
  const { data } = props
  const componentProps = { ...props, ...companyPillarsFactory.transform(data) }
  return <CompanyPillarsComponent {...componentProps} />
}
